import { styled } from '@mui/material/styles';

export const ActionWrapperBox = styled('div')`
  display: flex;
  justify-content: space-evenly;
  width: 100%;
`;
